var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "EXDialog",
    {
      attrs: {
        title: "附件详情",
        width: "40%",
        showVisible: _vm.curShowVisible
      },
      on: { close: _vm.close }
    },
    [
      _c(
        "div",
        [
          _c("div", { staticClass: "con-box" }, [
            _c("div", { staticClass: "each" }, [
              _c(
                "div",
                { staticStyle: { display: "block" } },
                _vm._l(_vm.attachments, function(row) {
                  return _c("div", { key: row.id }, [
                    _c(
                      "span",
                      {
                        staticClass: "filename",
                        on: {
                          click: function($event) {
                            return _vm.downloadFile(row)
                          }
                        }
                      },
                      [_vm._v(_vm._s(row.attachName))]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "size" }, [
                      _vm._v("（" + _vm._s(row.fileSize) + "kb）")
                    ]),
                    _vm._v(" "),
                    _c(
                      "span",
                      {
                        staticClass: "filename",
                        on: {
                          click: function($event) {
                            return _vm.previewFile(row)
                          }
                        }
                      },
                      [_vm._v("- 预览")]
                    )
                  ])
                }),
                0
              )
            ])
          ]),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c(
                "el-col",
                {
                  staticStyle: { "text-align": "center" },
                  attrs: { span: 24 }
                },
                _vm._l(_vm.operationHandle, function(item, index) {
                  return _c(
                    "el-button",
                    {
                      directives: [{ name: "reClick", rawName: "v-reClick" }],
                      key: index,
                      staticStyle: { "margin-right": "10px" },
                      attrs: {
                        plain: item.plain || false,
                        type: item.type || "primary",
                        icon: item.icon || "",
                        size: item.size || "medium"
                      },
                      on: {
                        click: function($event) {
                          return item.handle()
                        }
                      }
                    },
                    [_vm._v(_vm._s(item.label))]
                  )
                }),
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4d2bc6b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4d2bc6b2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EXDialog/EXAttachsDialog.vue
// module id = 443
// module chunks = 0